import { useMutation } from "@tanstack/react-query";
import useApiAuth from "./useApiAuth";
import UserLogin from "../interfaces/userLogin";

const useLogin = () => {
    const { login } = useApiAuth();

    return useMutation({
        mutationFn: (user: UserLogin) => login(user),
    })
}

export default useLogin;